import { FC } from 'react';
import { useFragment } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import EntitySidebar from 'components/EntitySidebar';

import { LabelSidebar_label$key } from '__generated__/LabelSidebar_label.graphql';

type Props = {
  label: LabelSidebar_label$key;
};

const LabelSidebar: FC<Props> = props => {
  const label = useFragment(
    graphql`
      fragment LabelSidebar_label on Label {
        ...EntitySidebar_entity
      }
    `,
    props.label
  );

  return <EntitySidebar entity={label} />;
};

export default LabelSidebar;
